<template> 
  <div class="input-number d-flex">
    <input v-model="inputNumber" @input="leaving()" @blur="leaving()" type="number" min="0" />
    <div>
      <div class="d-block cursor-pointer icon-arrow-up color-grey-3 fs-12 increment" @click="increment"></div>
      <div class="d-block cursor-pointer icon-arrow-down color-grey-3 fs-12 decrement" @click="decrement"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'inputNumber',
  props: {
    number: { type: Number },
  },
  data() {
    return {
      inputNumber: this.number
    }
  },
  watch: {
    number(){
      this.inputNumber = this.number;
    },
  },

  methods: {
    increment() {
      this.$emit('increment', this.number)
    },
    decrement() {
      if (this.number >= 0) {
        this.$emit('decrement', this.number)
      }
    },
    leaving() {
      const normalizedAmount = Math.max(0, parseInt(this.inputNumber, 10) || 0);
      if (normalizedAmount !== this.number) {
        this.$emit('setLuggage', normalizedAmount)
      }
    }
  }
}
</script>

<style lang="scss">
  .input-number {
    height: 52px;

    input {
      width: 52px;
      outline: 0;
      border: 1px solid #e2e2e2;
      box-shadow: none;
      padding: 8px;
    }

    .increment,
    .decrement {
      border-right: 1px solid #e2e2e2;
      border-top: 1px solid #e2e2e2;
      height: 26px;
      padding: 6px 8px;
    }

    .decrement {
      border-bottom: 1px solid #e2e2e2;
    }
  }
  // Hide input type="number" default arrows
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
</style>

